<div class="wrapper">
  <div class="filters">
    <pl-add-user></pl-add-user>
    <pl-search-form></pl-search-form>
    <pl-export-button></pl-export-button>
  </div>
  @if (!isOnTour) {
    <div class="notifications" style="text-decoration: none">
      <pl-notification-panel
        [notifications]="notifications"
      ></pl-notification-panel>
    </div>
  }
  @if (!isOnTour) {
    <pl-listing></pl-listing>
  }
  @if (isOnTour) {
    <pl-virtual-tour></pl-virtual-tour>
  }

  @if (!isOnTour && currentNotification) {
    <pl-new-features [not]="currentNotification"></pl-new-features>
  }
</div>
